import { useTranslation } from "react-i18next";

import { TYRE_POSITIONS } from "models";

const TyrePositionNameMap = new Map<TYRE_POSITIONS, [string, string]>([
  [TYRE_POSITIONS.CarFrontLeft, ["v8_front_left", "Front Left"]],
  [TYRE_POSITIONS.CarFrontRight, ["v8_front_right", "Front Right"]],
  [TYRE_POSITIONS.CarRearLeft, ["v8_rear_left", "Rear Left"]],
  [TYRE_POSITIONS.CarRearRight, ["v8_rear_right", "Rear Right"]],
  [TYRE_POSITIONS.StorageFrontLeft, ["v8_front_left", "Front Left"]],
  [TYRE_POSITIONS.StorageFrontRight, ["v8_front_right", "Front Right"]],
  [TYRE_POSITIONS.StorageRearLeft, ["v8_rear_left", "Rear Left"]],
  [TYRE_POSITIONS.StorageRearRight, ["v8_rear_right", "Rear Right"]],
  [TYRE_POSITIONS.TruckLeft, ["v8_left", "Left"]],
  [TYRE_POSITIONS.TruckRight, ["v8_right", "Right"]],
  [TYRE_POSITIONS.TruckExteriorLeft, ["v8_exterior_left", "Exterior Left"]],
  [TYRE_POSITIONS.TruckExteriorRight, ["v8_exterior_right", "Exterior Right"]],
  [TYRE_POSITIONS.TruckInteriorLeft, ["v8_interior_left", "Interior Left"]],
  [TYRE_POSITIONS.TruckInteriorRight, ["v8_interior_right", "Interior Right"]],
  [TYRE_POSITIONS.TruckSpare, ["v8_spare_tyre", "Spare Tyre"]]
]);

export const useTyrePositionName = (tyrePosition: TYRE_POSITIONS) => {
  const { t } = useTranslation();

  return t(...(TyrePositionNameMap.get(tyrePosition) ?? ["v8_unknown", "Unknown"]));
};
